import moment from 'moment';
import React, { Component } from 'react';
import { OverrideBool } from '../../utilities/utils';
import Footer from '../SubComponents/Footer/Footer';
import Header from '../SubComponents/Header/Header';
import ItemSelection from '../SubComponents/ItemSelection/ItemSelection';
import Modal, { DefaultModalParams } from '../SubComponents/Modal/Modal';
import PriceBar from '../SubComponents/PriceBar/PriceBarContainer';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './PartyRoomSelection.css';
import { notify, stopNotify } from '../../selectors/sequence';
import { addCustomTagEvent } from '../../utilities/customTag';


export default class PartyRoomSelection extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
      modalParams: DefaultModalParams
    };
    this.inputFrozen = false;
  }

  componentDidMount() {
    this.inputFrozen = false;

    this.minStationsCheck();
    notify(this.props.popups);
  }

  componentWillUnmount() {
    stopNotify();
  }

  onClickNext = () => {
    if (!this.inputFrozen) {
      if (this.props.getAnyOverCrowded()) {
        this.openModal({
          title: this.props.languageObj.click_next.overcrowding.title,
          content: this.props.languageObj.click_next.overcrowding.content,
          acceptText: this.props.languageObj.click_next.overcrowding.accept,
          cancelText: this.props.languageObj.click_next.overcrowding.cancel,
          isConfirm: true,
          onAccept: this.gotoNext
        });
      }
      else if (!this.props.totalPartyRooms && this.props.hasUnlockedRooms) {
        this.openModal({
          title: this.props.languageObj.click_next.no_party_selected.title,
          content: this.props.languageObj.click_next.no_party_selected.content,
          acceptText: this.props.languageObj.click_next.no_party_selected.accept,
          cancelText: this.props.languageObj.click_next.no_party_selected.cancel,
          isConfirm: true,
          onAccept: this.gotoNext
        });
      }
      else {
        this.gotoNext();
      }
    }
  }

  gotoNext = () => {
    this.inputFrozen = true;
    addCustomTagEvent({
        event: 'PartyNextEvent',
        category: 'Cart',
        label: 'Party Room'
    });
    this.props.transitionForward()
      .then(() => { this.inputFrozen = false; })
      .catch((error) => {
        this.inputFrozen = false;
        console.error(error);
      });
  }

  gotoPrev = () => {
    addCustomTagEvent({
        event: 'PartyBackEvent',
        category: 'Cart',
        label: 'Party Room'
    });
    this.props.transitionBack().catch((error) => {
      console.error('Failed to go back from party room selection: ' + error);
    });
  }

  onClickPrev = () => {

    if (!this.inputFrozen) {

      // remove party rooms on back click to prevent cheating a free room
      for(let key in this.props.generalizedItems.timeslots) {
        let timeslotId = this.props.generalizedItems.timeslots[key].timeslotId;
        let itemId = this.props.generalizedItems.timeslots[key].itemIds[0];

        let selectedPartyRoom = this.props.selectedPartyRooms[timeslotId];
        if(selectedPartyRoom !== undefined && selectedPartyRoom[itemId] > 0) {

          this.updateItemQuantity(timeslotId, itemId, 0);
          addCustomTagEvent({
              event: 'RemoveFromCart',
              category: 'Cart',
              label: 'Item Select',
              checkoutDetails: {
                onClick: 'ResetStatePrevPage',
                item: itemId,
                itemCategory: 2,
                quantity: 0
              }
          });
        }
      }

      this.gotoPrev();
    }
  }

  updateItemQuantity = (timeslotId, itemId, quantity) => {
    this.props.selectPartyRoom(timeslotId, itemId, quantity);
  }

  getTimeslotIndex = (timeslotId) => {
    let sortedTimeslots = [];
    for(let a in this.props.generalizedItems.timeslots) {
      sortedTimeslots.push(a);
    }

    sortedTimeslots.sort((a, b) => {
      if(a < b) return -1;
      else if(a > b) return 1;
      else return 0;
    })

    const index = sortedTimeslots.findIndex((val) => {return val === timeslotId});

    return index;
  }

  validateItemQuantity = (timeslotId, itemId, quantity) => {
    const index = this.getTimeslotIndex(timeslotId);
    const numStations = this.props.getNumberOfStationsInTimeslot(index);
    const partyRoomsData = this.props.partyRoomsData;
    if (partyRoomsData) {
      const partyRoom = partyRoomsData.partyRooms[itemId];
      if (partyRoom !== undefined) {
        const minimumStations = partyRoom.minimumStations;
        // if number of stations for this timeslot is > quantity + selected party room quantities -> good
        // if number of extra people from timesplits is > combined room occupancy of selected rooms, show alert before continuing
        if (numStations < minimumStations) {
          return OverrideBool.False;
        }
      }
    }
    return OverrideBool.None;
  }

  onCloseModal = () => {
    this.setState({
      modalOpen: false
    });
  }

  openModal = (params) => {
    this.setState({
      modalOpen: true,
      modalParams: params
    });
  }

  minStationsCheck = () => {

    if (!this.props.hasUnlockedRooms && !this.props.minumumStationsMet) {
      this.openModal({
        title: this.props.languageObj.click_next.no_minimum_stations.title,
        content: this.props.languageObj.click_next.no_minimum_stations.content,
        acceptText: this.props.languageObj.click_next.no_minimum_stations.accept,
        cancelText: this.props.languageObj.click_next.no_minimum_stations.cancel,
        isConfirm: true,
        onCancel: this.gotoPrev
      });
    }
  }

  render() {
    return (
      <div className={'AppContainer'}>
        <Header
          header={this.props.locationName.toLocaleUpperCase()}
          subHeader={moment(this.props.selectedDate).format('dddd, MMMM Do').toLocaleUpperCase()}
          hideOnMobile={true}
        />
        <div className={'PartyRoomSelection'}>
          <ItemSelection
            landscape={this.props.landscape}
            timeslots={this.props.generalizedItems.timeslots}
            items={this.props.generalizedItems.items}
            selectedItems={this.props.selectedPartyRooms}
            updateItemQuantity={this.updateItemQuantity}
            validateQuantity={this.validateItemQuantity}
            itemCategoryId={2} // Replace with not hard-coded after spine replacement
            isToggle={true}
            isLocalQuantity={true}
            noItemsMessage={this.props.languageObj.render.no_party_rooms}
          />
        </div>
        <ToastContainer
          className={'ToastContainer'}
          toastClassName={'Toast'}
          progressClassName={'ToastProgress'}
          position={'top-right'}
          newestOnTop={true}
          rtl={false}
        />
        <PriceBar isSubtotal={true} />
        <Footer
          nextName={this.props.languageObj.render.next_name}
          prevName={this.props.languageObj.render.prev_name}
          nextDisabled={this.props.totalPartyRooms < 0}
          prevDisabled={false}
          handleClickNext={this.onClickNext}
          handleClickPrev={this.onClickPrev}
          isPartyRoomSelection={true}
        />
        <Modal
          isOpen={this.state.modalOpen}
          handleClose={this.onCloseModal}
          {...this.state.modalParams}
          modalType={0}
        />
      </div>
    );
  }
}
